import { signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/UseAuthContext";
import db, { auth } from "../../Firebase/config";
import "./sidenav.css";

const SideNav = () => {
  const [user, setUser] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    getDoc(doc(db, "users", auth.currentUser.uid)).then((docSnap) => {
      if (docSnap.exists) {
        setUser(docSnap.data());
      }
    });
  }, []);

  const handleSignout = async () => {
    await signOut(auth);
    navigate("/login");
  };

  return (
    <div className="sidenav">
      <div className="profile">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ86HlhVK5rQb3dDNo0DhqhHWP3lhomenQEY-e19LXMg6orlGWzsI3nNLx6KB-6Ai2cQdU&usqp=CAU"
          alt="profile-pic"
        />
        <h3>{user?.name}</h3>
      </div>
      <div className="sidenav-links">
        <div className="sidenav-link">
          <Link to="/dashboard">History Of Complaints</Link>
        </div>
        <div className="sidenav-link">
          <Link to="/">Make Complaint</Link>
        </div>
      </div>
      <div className="logout">
        <Button
          variant="danger"
          onClick={handleSignout}
          style={{ marginTop: 10 }}
        >
          LOGOUT
        </Button>
      </div>
    </div>
  );
};

export default SideNav;
